import React, { useEffect, useState } from "react";
import { GetBaseUrl } from "./modules/getBaseUrl";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function HeaderOptions(props) {
  const [Link, setLink] = useState("");
  const navigate = useNavigate();
  const tokenData = useSelector((state) => state.tokens.tokens);
  const raiseField = (type) => {
    let url = GetBaseUrl(window.location.href);
    if (type === "home") {
      if (tokenData.isAlumni) {
        window.location.replace(url +"/application/alumni/connect"); 
        // navigate("/application/alumni/connect");
      } else if (tokenData.applicationStatus === "Registered") {
        // navigate("/application");
        window.location.replace(url + "/application");
      } else {
        // navigate("/application/submitted-status");
        window.location.replace(url + "/application/submitted-status");
      }
      // }
    } else if (type === "status") {
      // window.location.replace(url + "/application/app-preview");
      navigate("/application/app-preview");
    } else if (type === "connect") {
      if (tokenData.isAlumni) {
        // navigate("/application/alumni/connect");
        window.location.replace(url + "/application/alumni/connect");

      } else {
        // navigate("/application/connect");
        window.location.replace(url + "/application/connect");
      }
    } else if (!props.isLogin) {
      navigate("/application/help");
      // window.location.replace(url + "/application/help");
    } else {
      // window.location.replace(url + "/help");
      navigate("/help");
    }
  };
  useEffect(() => {
    let currentUrl = window.location.href;
    // const url = new URL(currentUrl);
    // const baseUrl = `${url.protocol}//${url.host}`;
    const cleanedUrl = currentUrl.replace(/^https?:\/\/(www\.)?/, "");
    // console.log("window", cleanedUrl.split("/")[0]);
    setLink(cleanedUrl);
  }, []);
  return (
    <div className="header-center">
      <div className="header-options">
        {!props.isLogin && (
          <div
            onClick={() => raiseField("home")}
            className={`header-text pointer header-option ${
              (Link.split("/")[1] === "application" && !Link.split("/")[2]) ||
              Link.split("/")[2] === "submitted-status"
                ? "selected"
                : ""
            }`}
          >
            Home
          </div>
        )}
        {/* {tokenData.token && tokenData.applicationStatus !== "Registered" && (
          <div
            onClick={() => raiseField("status")}
            className={`header-text pointer header-option ${
              Link.split("/")[2] === "app-preview" ? "selected" : ""
            } `}
          >
            Status
          </div>
        )} */}
        {tokenData.token && tokenData.applicationStatus === "Awarded" && (
          <div
            onClick={() => raiseField("connect")}
            className={`header-text pointer header-option ${
              Link.split("/")[2] === "connect" ? "selected" : ""
            } `}
          >
            Connect
          </div>
        )}
        <div
          onClick={() => raiseField("help")}
          className={`header-text pointer header-option 
          ${
            Link.split("/")[1] === "help" ||
            Link.split("/")[2]?.includes("help")
              ? "selected"
              : ""
          }`}
        >
          Help
        </div>
      </div>
    </div>
  );
}

export default HeaderOptions;
